import React from "react";
import PageHero from "../components/PageHero";
import { Target, Compass, Handshake, Sparkles } from "lucide-react";
import TrustSection from "../components/TrustSection";
import Testimonials from "../components/Testimonials";
import CyberRiskCTA from "../components/CyberRiskCTA";
import TechPartners from "../components/TechPartners";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About Techmate"
        title="Your strategic cybersecurity consulting partner."
        subtitle="Techmate Infosec Solutions is a consulting-led security and compliance advisory firm. We architect, deliver and operate secure, scalable, compliance-ready environments — from hybrid infrastructure and data protection to managed security and regulatory readiness. Headquartered in Pune, serving India and global enterprises."
      />
      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-start">
          <div className="rounded-3xl border border-border bg-card p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 text-primary text-xs font-semibold uppercase tracking-widest"><Target className="h-4 w-4" /> Mission</div>
            <h3 className="mt-3 font-display text-2xl sm:text-3xl font-bold">Enable organizations to operate securely, efficiently and with confidence.</h3>
            <p className="mt-4 text-muted-foreground leading-relaxed">
              Every engagement starts with the business — the process, the people, the regulator, the customer.
              Technology is chosen to serve the outcome, never the other way around.
            </p>
          </div>
          <div className="rounded-3xl border border-border bg-card p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 text-secondary text-xs font-semibold uppercase tracking-widest"><Compass className="h-4 w-4" /> Approach</div>
            <ul className="mt-4 space-y-3 text-sm sm:text-base">
              {[
                { icon: Handshake, t: "Vendor-neutral consulting" },
                { icon: Sparkles, t: "Compliance-first frameworks (ISO 27001, DPDP, SOC 2)" },
                { icon: Target, t: "Business-driven security outcomes" },
                { icon: Compass, t: "Executive-grade reporting for boards" },
              ].map((x, i) => {
                const Icon = x.icon;
                return (
                  <li key={i} className="flex items-start gap-3">
                    <div className="h-8 w-8 rounded-lg bg-primary/10 text-primary grid place-items-center shrink-0"><Icon className="h-4 w-4" /></div>
                    <span className="font-medium">{x.t}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
      <TrustSection />
      <TechPartners />
      <Testimonials />
      <CyberRiskCTA />
    </div>
  );
}
